"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const UserRegistrationContext_1 = require("@/context/UserRegistrationContext");
const react_google_recaptcha_v3_1 = require("react-google-recaptcha-v3"); // Import Google reCAPTCHA v3
const EmailRegistrationForm_1 = __importDefault(require("./EmailRegistrationForm")); // Import the new component
const EmailRegistration = () => {
    const { appProps } = (0, UserRegistrationContext_1.useUserRegistration)();
    const { isCaptchaEnabled, captchaPublicKey } = appProps;
    const isCaptchaEnabledByQueryParam = () => {
        const urlParams = new URLSearchParams(globalThis.location.search);
        return urlParams.has('enableCaptcha');
    };
    const isCaptchaAuthorizedOnThePage = () => {
        return (isCaptchaEnabled || isCaptchaEnabledByQueryParam()) && !!captchaPublicKey;
    };
    return isCaptchaAuthorizedOnThePage() ? (react_1.default.createElement(react_google_recaptcha_v3_1.GoogleReCaptchaProvider, { reCaptchaKey: captchaPublicKey },
        react_1.default.createElement(EmailRegistrationForm_1.default, { isCaptchaAuthorized: isCaptchaAuthorizedOnThePage() }))) : (react_1.default.createElement(EmailRegistrationForm_1.default, { isCaptchaAuthorized: isCaptchaAuthorizedOnThePage() }));
};
exports.default = EmailRegistration;
